<template>
    <div class="flex items-center w-5/6">
        <div v-if="custom" class="w-full flex items-center">
            <div class="w-full w-full flex items-center justify-stretch">
                <div class="mr-2">Over</div>
                <div class="border border-gray-200 hover:border-gray-400 focus:border-gray-400 rounded-full bg-white">
                    <input ref="input" @keyup.enter="activate" class="w-full px-2 py-1 font-extralight bg-transparent outline-none" type="number" step="1" min="0" v-model="quantity" placeholder="Quantity">
                </div>
            </div>

            <a href="#" @click.prevent="activate" class="ml-2 flex items-center justify-center text-white bg-green-500 hover:bg-green-600 hover:text-white h-6 rounded px-3 text-sm">
                Go
            </a>
        </div>
        <div v-else v-text="option.display"></div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            required: false,
            default() {
                return null;
            }
        },

        option: {
            type: Object,
            required: true,
        },

        active: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            quantity: this.value || null,
        };
    },

    mounted() {
        if (! this.custom) {
            return;
        }

        this.$on('focus', this.focus);

        this.$nextTick(() => {
            if (! this.active || this.quantity) {
                return;
            }

            let quantity = this.value;

            try {
                quantity = Number(this.$route.query['filter[quantity]']);
            } catch (e) { /** do nothing */ }

            this.quantity = quantity;
        });
    },

    beforeDestroy() {
        this.$off('focus', this.focus);
    },

    watch: {
        value(value) {
            this.quantity = value;
        },

        quantity() {
            if (! this.custom) {
                return;
            }

            this.$emit('input', this.quantity ? Number(this.quantity) : null);
        },
    },

    computed: {
        custom() {
            return 'custom' === this.option.slug;
        },
    },

    methods: {
        activate() {
            let query = null;

            try {
                query = Number(this.$route.query['filter[quantity]']);
            } catch (e) { /** do nothing */ }

            if (this.active && Number(this.quantity) === this.value && query === this.value) {
                return;
            }

            if (0 === Number(this.quantity)) {
                return;
            }

            this.$emit('activate');
        },

        focus() {
            this.$refs.input.focus();
        },
    },
};
</script>

